import styled from 'styled-components';

export const SubtitleWrapper = styled.p`
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 8px;
  text-align: center;
  color: ${(props) => props.theme.colors.muted};
`;

export const NotificationWrapper = styled.div`
  margin-bottom: 32px;
`;

export const ContentWrapper = styled.div`
  max-width: 468px;
`;

export const ValidationSwitchWrapper = styled.div`
  margin-bottom: 24px;
`;
